import React, { useEffect } from 'react';
import Button from '../../Shared/UI/Button/components/Button';

import {
  useEventState,
  useEventActions
} from './EventContext';

import {
  getAuthenticatedEventAttendeeByAuthenticatedUser,
  getAuthenticatedEventAttendeeByInviteEmailAndInviteCode,
  acceptEventInvitation,
  declineEventInvitation,
} from './restApi';

import styles from './EventAttendees.module.scss';

const EventRSVP = () => {
  const state = useEventState();
  const { onResponse, onError } = useEventActions();

  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const rsvpYesButtonStyle = (state?.authenticatedEventAttendee?.rsvpResponse == 'yes') ?
    styles.selectedRSVPBtn :
    styles.unselectedRSVPBtn;

  const rsvpNoButtonStyle = (state?.authenticatedEventAttendee?.rsvpResponse == 'no') ?
    styles.selectedRSVPBtn :
    styles.unselectedRSVPBtn;

  const getAuthenticatedEventAttendee = () => {
    if (state?.inviteEmail && state?.inviteCode) {
      getAuthenticatedEventAttendeeByInviteEmailAndInviteCode({
        id: state?.event?.id,
        onResponse,
        onError,
        inviteEmail: state?.inviteEmail,
        inviteCode: state?.inviteCode,
      });
    } else {
      getAuthenticatedEventAttendeeByAuthenticatedUser({
        id: state?.event?.id,
        onResponse,
        onError,
      });
    }
  };

  useEffect(() => {
    getAuthenticatedEventAttendee();
  }, []);

  return state?.authenticatedEventAttendee ? (
    <div className={styles.event}>
      <div id={styles.rsvpContainer}>
        <h2 className={styles.tableTitle}>
          RSVP
        </h2>
        <p>Will you attend the event?</p>
        <div>
          <div className={rsvpYesButtonStyle}>
            <Button
              variant="secondary"
              onClick={() => {
                acceptEventInvitation({
                  id: state?.event?.id,
                  onResponse,
                  onError,
                  body: {
                    authenticity_token: authenticityToken,
                    event_attendee_id: state?.authenticatedEventAttendee.id,
                  },
                });
              }}
            >
              Yes
            </Button>
          </div>
          <div className={rsvpNoButtonStyle}>
            <Button
              variant="secondary"
              onClick={() => {
                declineEventInvitation({
                  id: state?.event?.id,
                  onResponse,
                  onError,
                  body: {
                    authenticity_token: authenticityToken,
                    event_attendee_id: state?.authenticatedEventAttendee.id,
                  },
                });
              }}
            >
              No
            </Button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default EventRSVP;
